export default __webpack_public_path__ + "static/media/navbar-icon-new.2935f5b1.svg";